import { useTaskPlannedOccurrenceForDate } from '@griply/hooks';
import { getTaskPlanning } from '@griply/utils';
import { useMemo } from 'react';
import { DateRange } from 'shared/types/date-range';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';

export type UseTaskDisplayDateOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
  dateRange?: DateRange;
  uncompletedOnly?: boolean;
};

export const useTaskDisplayDate = (
  task: Task,
  referenceDate: Timestamp,
  {
    today,
    weekStartsOn,
    dateRange,
    uncompletedOnly = true,
  }: UseTaskDisplayDateOptions,
  enabled = true,
): Timestamp => {
  const plannedOccurrenceInRange = useMemo(() => {
    if (!enabled || !dateRange) {
      return undefined;
    }

    const [earliest] = getTaskPlanning(task, {
      ...dateRange,
      today,
      weekStartsOn,
      uncompletedOnly,
      sinceLastEntryOnly: true,
      strictEndDate: true,
    });

    return earliest;
  }, [enabled, dateRange, task, today, weekStartsOn, uncompletedOnly]);

  const plannedOccurrenceForReference = useTaskPlannedOccurrenceForDate(
    task,
    referenceDate,
    { today, weekStartsOn, uncompletedOnly },
    enabled,
  );

  return (
    plannedOccurrenceInRange?.date ??
    plannedOccurrenceForReference?.date ??
    referenceDate
  );
};
